/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../../constants'

import AddForm from './addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedEquipment: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, user_type } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedEquipment
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Barangay Management</a></li>
									<li className="breadcrumb-item active">Equipment</li>
								</ol>
							</div>
							<h4 className="page-title">Equipment</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row>
									<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
										this.setState({ isAddFormShown: true, isEdit: false, selectedEquipment: null })
									}} style={{ float: 'right' }}>Add New</button>
									<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
										this.setState({ searchText: e.target.value })
									}}/>
								</Row>
								<br />
								<Row>
									<Query query={BARANGAY_EQUIPMENTS} variables={{ searchFilter: filters, barangay_uid }}>
										{({ loading, error, data }) => {
											if (error) return <Empty/>

											let allBorrowedEquipments = _.has(data,'allBorrowedEquipments') ? data.allBorrowedEquipments.data : []
											allBorrowedEquipments = allBorrowedEquipments.map((allBorrowedEquipment, key) => Object.assign({}, allBorrowedEquipment, { key }))
											let _pagination = _.has(data, 'allBorrowedEquipments') ? data.allBorrowedEquipments.pagination : {}
											_pagination = Object.assign({}, _pagination, {
												pageSizeOptions: ['10', '25', '50'],
												showSizeChanger: true,
												total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
												showTotal: (total) => `Total ${total} items`
											})

											const columns = [
												{
													title: 'Equipment',
													dataIndex: 'equipment_name',
													key: 'equipment_name',
												//width: 300
												}, {
													title: 'Name of Borrower',
													dataIndex: 'constituent_name',
													key: 'constituent_name'
												}, {
													title: 'Status',
													dataIndex: 'status',
													key: 'status'
												}, {
													title: 'Date Borrowed',
													key: 'date_borrowed',
													render: (record) => (
														<span>{moment(record.date_borrowed).format('lll')}</span>
													)
												}, {
													title: 'Date Returned',
													key: 'date_returned',
													render: (record) => (
														<span>{
															moment(record.date_returned).isValid() ?
																moment(record.date_returned).format('lll') : '- - -'
														}</span>
													)
												}, {
													title: 'Remarks',
													dataIndex: 'remarks',
													key: 'remarks'
												}, {
													title: 'Action',
													key: 'action',
													render: (record) => {
														return (
															<React.Fragment>
																{
																	!_.isEqual(record.status,'RETURNED') &&
																	<a href="#" style={{ marginRight: 10 }} onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedEquipment: record })}>Edit</a>
																}
																{
																	isAdmin &&
																	<Popconfirm
																		title="Are you sure delete this equipment reservation?"
																		onConfirm={() => {
																			const { deleteEquipmentReservation } = this.props
																			deleteEquipmentReservation({ equipment_uid: record.uid })
																				.then((response) => {
																					message.success('Successfully deleted.')

																					//create audit trail
																					const auditParams = {
																						module_name: 'Equipments',
																						action: 'Delete',
																						message: `Deleted equipment reservation for ${record.equipment_name}`
																					}
																					AuthStore.saveAuditTrail(auditParams)
																				}).catch(err => {
																					console.log('error deleting equipment reservation', err)
																					message.error(err.message.replace('GraphQL error:', ''))
																				})
																		}}
																		// onCancel={cancel}
																		okText="Yes"
																		cancelText="No"
																	>
																		<a href="javascript:void(0)" >Delete</a>
																	</Popconfirm>
																}
															</React.Fragment>
														)
													}
												}]
											return (
												<Table 
													loading={loading}
													columns={columns} 
													dataSource={allBorrowedEquipments} 
													bordered
													onChange={this.handleOnChange}
													pagination={_pagination}
													scroll={{ x: 1020 }}
												/>
											)
										}}
									</Query>
								</Row>
							</div>
						</div>
					</div>
				</div>
				{
					isAddFormShown &&
					<AddForm
						isEdit={isEdit}
						selectedBorrowedEquipment={selectedEquipment}
						visible={isAddFormShown}
						onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedEquipment: null })}
					/>
				}
			</React.Fragment>
		)
	}
}

const BARANGAY_EQUIPMENTS = gql`
    query allBorrowedEquipments($barangay_uid: String, $searchFilter: SearchParams) {
		allBorrowedEquipments(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const DELETE_EQUIPMENT_RESERVATION = gql`
    mutation deleteEquipmentReservation($input: JSON) {
		deleteEquipmentReservation(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_EQUIPMENT_RESERVATION, {
		props({ mutate }) {
			return {
				deleteEquipmentReservation(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBorrowedEquipments']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
